module.exports = __webpack_public_path__ + "img/menu_camera_whi@3x.45bef450.png";